import { tv } from 'tailwind-variants'

export const messagesManagement = tv({
  slots: {
    container: 'flex-1 flex flex-row max-w-[80%]',
    messages: 'h-full w-full m-mili rounded-mili bg-white',
    clientProfile: 'h-full rounded-mili bg-white min-w-[350px]',
    accordion: 'flex mt-mili',
    loading: 'flex w-full items-center place-content-center',
    pip: 'w-full h-full bg-white'
  }
})
